import { colors } from '../colors';

export const tooltip = {
  backgroundColor: colors.blue[800],
  arrow: {
    color: colors.blue[800],
  },
};
